module.exports = __webpack_public_path__ + "media/images/lb/910-7147cc138cb04fe42935b9df6592774c.svg";